(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wrld-home-presale-v1"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wrld-presale-popup')) {
  customElements.define('wrld-presale-popup', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.key = 'wrld-presale-2026-seen';
      this.lifetime = 7 * 24 * 60 * 60 * 1000;
      this.readyAt = Date.now() + 10000;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.querySelectorAll('[data-wrld-close]').forEach(button => button.addEventListener('click', () => this.dialog.close(), options));
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        document.documentElement.classList.remove('wrld-popup-open');
        if (this.previousFocus instanceof HTMLElement && this.previousFocus.isConnected) this.previousFocus.focus({ preventScroll: true });
      }, options);
      this.querySelectorAll('a').forEach(link => link.addEventListener('click', () => this.dialog.close(), options));
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      window.addEventListener('scroll', () => this.schedule(), { ...options, passive: true });
      this.schedule();
    }
    seenRecently() {
      for (const name of ['localStorage', 'sessionStorage']) {
        try {
          const seen = Number(window[name].getItem(this.key));
          if (seen > 0 && Date.now() - seen < this.lifetime) return true;
        } catch (error) { continue; }
      }
      return false;
    }
    schedule() {
      if (this.shown || this.timer || this.seenRecently()) return;
      this.timer = window.setTimeout(() => {
        this.timer = null;
        this.openWhenReady();
      }, Math.max(500, this.readyAt - Date.now()));
    }
    openWhenReady() {
      if (!this.isConnected || this.shown || this.seenRecently() || document.hidden) return;
      if (window.matchMedia('(max-width: 800px)').matches && window.scrollY < 120) return;
      const active = document.activeElement;
      const interacting = active && active.matches('input, textarea, select, [contenteditable="true"]');
      const overlayOpen = [...document.querySelectorAll('dialog[open], [aria-modal="true"], #DrawerOverlay, #ThemeModal, #QuizModal, #PopupOverlay, .drawer-overlay')].some(element => {
        if (element === this.dialog) return false;
        const style = window.getComputedStyle(element);
        const bounds = element.getBoundingClientRect();
        return bounds.width > 0 && bounds.height > 0 && bounds.bottom > 0 && bounds.right > 0 && bounds.top < window.innerHeight && bounds.left < window.innerWidth && style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity) > 0;
      });
      if (interacting || overlayOpen) {
        this.readyAt = Date.now() + 2000;
        this.schedule();
        return;
      }
      this.previousFocus = active;
      this.dialog.showModal();
      this.shown = true;
      document.documentElement.classList.add('wrld-popup-open');
      this.querySelector('[data-wrld-close]').focus({ preventScroll: true });
      for (const name of ['localStorage', 'sessionStorage']) {
        try { window[name].setItem(this.key, String(Date.now())); } catch (error) { continue; }
      }
    }
    disconnectedCallback() {
      window.clearTimeout(this.timer);
      this.controller?.abort();
      if (this.dialog?.open) this.dialog.close();
      document.documentElement.classList.remove('wrld-popup-open');
      this.timer = null;
      this.initialized = false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
